import MissingPlotLocation from './MissingPlotLocation';

export default MissingPlotLocation;
